import { MYNAVI_PRIMARY } from '@/components/Campaign/mynavi/Color'
import { MyNaviButton } from '@/components/Campaign/mynavi/MyNaviButton/MyNaviButton'
import { MyNaviTypography } from '@/components/Campaign/mynavi/MyNaviUI/MyNaviTypography'
import { Dialog } from '@/components/UI/Dialog'

type Props = {
  opened: boolean
  onRegister: () => void
  onSkip: () => void
}

export const DialogEmailRegistrationPrompt = ({ opened, onRegister, onSkip }: Props) => {
  return (
    <Dialog selectorState={opened} showCloseButton={false} closeOnClickOutside={false} lockScroll>
      <div className="flex flex-col gap-4 pb-2">
        <MyNaviTypography variant="dialog-title" as="p" className="text-center m-0" style={{ color: MYNAVI_PRIMARY }}>
          メールアドレス登録のお願い
        </MyNaviTypography>
        <div style={{ lineHeight: 1.35 }}>
          <MyNaviTypography variant="search-hint" as="p" className="m-0">
            PayPayポイントの交換にメールアドレスが必要になります。
          </MyNaviTypography>
          <p style={{ margin: 0 }}></p>
          <MyNaviTypography variant="search-hint" as="p" className="m-0">
            登録を行いますか？
          </MyNaviTypography>
        </div>
        <MyNaviButton label="登録画面へ" showIcon={false} onClick={onRegister} fullWidth />
        <div className="flex justify-center">
          <button
            type="button"
            onClick={onSkip}
            style={{
              fontSize: '15px',
              color: MYNAVI_PRIMARY,
              textDecoration: 'underline',
              fontFamily: "'Noto Sans JP', sans-serif",
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
            }}
          >
            あとから登録する
          </button>
        </div>
      </div>
    </Dialog>
  )
}
